import React from 'react'

import { 
    Modal, 
    Tabs,
    Button,
    Form,
    Input,
    Row,
    Col,
    message,
    Upload,
    Icon,
    Radio,
} from 'antd'

import {
    _postCommunityImage
} from '../../services'

import { API_ENDPOINT } from '../../index';

const { TabPane } = Tabs;

class PhotoModal extends React.Component {

    constructor(props){
        super( props );

        this.state = {
            visible: this.props.visible,
            activeVideoUrl: ''
        }
    }

    closeModal=()=>{
        this.setState({visible:false});
        this.props.closePhotoModal();
    }

    renderImagePreview = () => {

		// const { user } = this.props;

		// if( user.userData && user.userData.details && user.userData.details.profileImage ){
		// 	return <img src={user.userData.details.profileImage} style={{ height: 100, width: 100 }} />
		// }

		return [
			<Icon type={ this.state.uploading ? 'loading' : 'plus'} />,
			<div className="ant-upload-text">Upload Image</div>
		];
		
  }

    handleAddVideo = () => {
        const { activeVideoUrl } = this.state

        if( !activeVideoUrl.includes('youtube.com/embed') ){
            return message.error("Invalid video source!")
        }

        this.props.onAddVideo(activeVideoUrl)

        this.setState({ activeVideoUrl: '' })
    }

    handleSelectVideo = (e, video) => {
        e.preventDefault()

        this.props.onAddVideo(video)
    }

    handleAddUrl = (e) => {
        e.preventDefault();
        console.log('handleAddUrl')
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let { mediaType, mediaUrl } = values;
                if (mediaType=='image') {
                    console.log(mediaUrl)
                    this.props.onAddImage( mediaUrl )
                } else {
                    console.log(mediaUrl)
                    this.props.onAddVideo( mediaUrl )
                }

                }
        })
        this.props.closePhotoModal();
    }

    handleAddUploadImage = ( res ) => {
        if( res.file.status == "done" ){
            console.log('done')
            this.props.onAddImage(res.file.response.docImage.url)
        }
    }

    beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
      }
  
    render() {
        return (
            <Modal 
                visible={this.state.visible}
                // onOk={this.handlePostThread}
                // onKey
                onCancel={this.closeModal}
                footer={null}
                title="Upload Media"
                >
                {this.renderForm()}
            </Modal>
        )
    }

    renderForm() {

        const operations = <Button>Extra Action</Button>;

        const { getFieldDecorator } = this.props.form;
        
        let action = '';
        switch( this.props.source ) {
            case 'community':
                action = `${API_ENDPOINT}/api/upload/community-image`
                break;
            case 'doc':
                action = `${API_ENDPOINT}/api/upload/doc-image`
                break;
            default:
                action = '';
        }

        const uploadTab = 
            <Upload
            action={action}
                name="picture"
                listType="picture-card"
                showUploadList={true}
                beforeUpload={ this.beforeUpload }
                onChange={ this.handleAddUploadImage }
                withCredentials={true}
                >
                <div>
                    { this.renderImagePreview() }
                </div>
            </Upload>

        const urlTab = 

            <Form 
                layout="inline" 
                onSubmit={this.handleAddUrl}>
                <Form.Item label="Media Type">
                    {getFieldDecorator('mediaType', {
                        initialValue: 'image',
                        rules: [
                            {
                              required: true,
                              whitespace: true,
                              message: "Please choose a Media Type"
                            }
                          ]
                    })(
                        <Radio.Group name="radiogroup">
                        <Radio value="image">Image</Radio>
                        <Radio value="video">Video</Radio>
                        </Radio.Group>,
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('mediaUrl', {
                    })(
                        <Input
                            placeholder="Insert Media URL here"
                            style={{width: 350}}
                        />,
                    )}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Insert Media
                    </Button>
                </Form.Item>
            </Form>

        return(
            <Tabs>
                <TabPane tab="Image" key="image">
                    <Row type="flex" gutter={12}>
                        <Col span={6} style={{marginBottom: 12}}>
                            {uploadTab}
                        </Col>
                        {this.props.images && this.props.images.map( _img => (
                            <Col span={6} style={{marginBottom: 12}}>
                                <img 
                                onClick={()=>this.props.onAddImage(_img)}
                                style={{
                                    height: 102.22,
                                    width: 102.22,
                                    cursor: 'pointer'
                                }}
                                src={_img}/>
                            </Col>
                        ))}
                    </Row>
                </TabPane>
                <TabPane tab="Video" key="video">
                    <Row type="flex" gutter={12} style={{marginBottom: 12}}>
                        <Col span={20}>
                            <Input 
                            onPressEnter={this.handleAddVideo}
                            value={this.state.activeVideoUrl}
                            onChange={e => this.setState({ activeVideoUrl: e.target.value })}
                            placeholder="https://www.youtube.com/embed/videoId"/>
                        </Col>
                        <Col>
                            <Button 
                            onClick={this.handleAddVideo}
                            type="primary"
                            icon="plus" shape="circle"/>
                        </Col>
                    </Row>         
                    <Row type="flex">
                        {this.props.videos && this.props.videos.map( _video => (
                            <Col span={12} style={{marginBottom: 12}}>
                                <iframe 
                                    style={{
                                        height: 150,
                                        width: 200
                                    }}
                                    src={_video}
                                    frameBorder='0'
                                    allow='autoplay; encrypted-media'
                                    allowFullScreen
                                    title='video'
                                />
                                    <Button
                                        size="small"
                                        onClick={(e)=>this.handleSelectVideo(e, _video)}
                                    >Select</Button>
                            </Col>
                        ))}
                    </Row>
                </TabPane>
                {/* <TabPane tab="URL" key="2">
                {urlTab}
                </TabPane>
                <TabPane tab="Saved" key="3">
                Content of tab 3
                </TabPane> */}
            </Tabs>
        )
    }

}

const WrappedPhotoModal= Form.create({})(PhotoModal);

export default WrappedPhotoModal


// WEBPACK FOOTER //
// ./src/components/docs/photo-modal.js